import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidLocationPinAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 20H5c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1Zm-7.7-2.3c.4.4 1 .4 1.4 0l4.1-4.1c2.7-2.7 2.7-7 0-9.6-2.7-2.7-7-2.7-9.6 0-2.7 2.7-2.7 7 0 9.6l4.1 4.1ZM12 6.8c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2Z"/>
  </SvgIcon>
}

export default SolidLocationPinAltIcon
